import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { DiscoveryChatQuestion, DiscoveryResponse } from '../model/discovery-chat.interface';

@Component({
  selector: 'app-discovery-wizard-base-current-question',
  template: `
  <p>
  </p>
`,
  styleUrls: ['./discovery-wizard-base-current-question.component.scss']
})
export class DiscoveryWizardBaseCurrentQuestionComponent extends BaseComponent implements OnInit {
  @Input() currentQuestion?: DiscoveryChatQuestion;
  @Input() isLoading: boolean = true;
  @Input() allowTheUserToCancel : boolean = false;
  @Output() sendQuestionResponseEvent = new EventEmitter<DiscoveryResponse[]>();
  @Output() cancelProcessEvent = new EventEmitter();
  
  imageRootFolder = "assets/common/"; 
  isAllResponsesAnswered: boolean = true;

  constructor() { 
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

}
